import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../../../utils/helpers";

let checkSequence = 0;
// Pakettransport (W6.5): Ein reines Designpaket hat keine iFlows; seine leere Artefaktliste ist gültig.
const wholePackage = (payload, item) => payload.packages.some(pkg => pkg.packageId === item.sourcePackageId && pkg.transport === "package");
export function validPreflightResponse(response, payload, checkId) {
  return response?.allowed === true && response.checkId === checkId
    && typeof response.checkedAt === "string" && Number.isFinite(Date.parse(response.checkedAt))
    && Array.isArray(response.packages) && response.packages.length > 0
    && response.packages.every(item => item && typeof item.packageId === "string" && item.packageId
      && item.sourceInstanceId === payload.sourceInstanceId && typeof item.targetInstanceId === "string" && item.targetInstanceId
      && payload.packages.some(pkg => pkg.packageId === item.sourcePackageId)
      && Array.isArray(item.artifactIds) && (item.artifactIds.length > 0 || wholePackage(payload, item)) && item.artifactIds.every(id => typeof id === "string" && id))
    && payload.packages.every(pkg => response.packages.some(item => item.sourcePackageId === pkg.packageId));
}

export default function useTransportPreflight({ payload, enabled }) {
  const key = JSON.stringify(payload);
  const current = useRef({ key, enabled });
  current.current = { key, enabled };
  const generation = useRef(0);
  const inFlight = useRef(null);
  const [state, setState] = useState({ key: null, loading: false, allowed: false, error: null });
  const reload = useCallback(async () => {
    if (!enabled || key === "null" || inFlight.current === key) return null;
    const version = ++generation.current;
    inFlight.current = key;
    setState({ key, loading: true, allowed: false, error: null });
    const checkId = `${Date.now()}-${++checkSequence}`;
    const matches = () => version === generation.current && current.current.enabled && current.current.key === key;
    try {
      const result = await api("/api/cicd/transport/preflight", { method: "POST", cache: "no-store", timeout: 180000,
        body: JSON.stringify({ ...JSON.parse(key), checkId }) });
      if (!validPreflightResponse(result, JSON.parse(key), checkId))
        throw Object.assign(new Error("TRANSPORT_PREFLIGHT_RESPONSE_INVALID"), { code: "TRANSPORT_PREFLIGHT_RESPONSE_INVALID" });
      if (!matches()) return null;
      setState({ key, loading: false, allowed: true, error: null });
      return result;
    } catch (error) {
      if (matches()) setState({ key, loading: false, allowed: false, error });
      return null;
    } finally { if (version === generation.current) inFlight.current = null; }
  }, [key, enabled]);
  // Editing invalidates an old check but never starts a network request.
  useEffect(() => {
    generation.current += 1;
    inFlight.current = null;
    setState({ key, loading: false, allowed: false, error: null });
    return () => { generation.current += 1; inFlight.current = null; };
  }, [key, enabled]);
  const canCheck = enabled && key !== "null";
  return state.key === key && canCheck ? { ...state, canCheck, reload }
    : { loading: false, allowed: false, error: null, canCheck, reload };
}
